// 商务联系方式 - 雷承业
export const businessInfo = {
  name: '雷先生',
  wechat: 'CY_0063',
  email: 'leichengye@netjoy.com'
}

// 商务联系方式 2 - 陶银
export const businessInfo2 = {
  name: '陶先生',
  wechat: '1074463',
  email: 'taoyin@netjoy.com'
}

// 数据报表 - 时间范围
export const dataTimeTypes = [
  {
    text: '日',
    value: 1
  },
  {
    text: '周',
    value: 2
  },
  {
    text: '月',
    value: 3
  }
]

// 数据报表 - 明细筛选项 - 列表类型
export const detailTypes = {
  // 部门
  dep: 1,
  // 成员
  member: 2,
  // 项目
  project: 3
}